<ng-container *ngIf="decision">
    <div class="cell auto grid-y">
        <kiwi-decision-content class="decision cell-block-y">
            <table class="cell shrink _tableColor">
                <tbody>
                <tr class="_titlePartTable">
                    <td class="_number"[i18nKey]="'decisions.communication.target.audience'"></td>
                    <td class="_number"[i18nKey]="'decisions.communication.advertisement.budget'"></td>
                    <td class="_number"[i18nKey]="'decisions.communication.main.communication.axis'"></td>
                    <td class="_number"[i18nKey]="'decisions.communication.secondary.communication.axis'"></td>
                </tr>

                <tr>
                    <td>
                        <input [(ngModel)]="decision.targetAudience"
                               type="number"
                               min="{{decision.minTargetAudience}}"
                               max="{{decision.maxTargetAudience}}"
                               (ngModelChange)="updateScoreImage()"
                               [disabled]="decisionsReadonly"/>

                    </td>

                    <td>
                        <kiwi-currency-input [(ngModel)]="decision.advertisementBudget"
                                             [min]="decision.minAdvertisementBudget"
                                             [max]="decision.maxAdvertisementBudget"
                                             (ngModelChange)="updateScoreImage()"
                                             name="advertisementBudget"
                                             [disabled]="decisionsReadonly"></kiwi-currency-input>
                    </td>

                    <td>
                        <select class="_color _alignRight" [(ngModel)]="decision.mainCommunicationAxis"
                                (ngModelChange)="updateScoreImage()"
                                [disabled]="decisionsReadonly">
                            <option
                                *ngFor="let axis of parameters.communicationParameters.communicationAxes | keys"
                                [value]="axis">
                                {{'axis.' + axis | translate}}
                            </option>
                        </select>
                    </td>

                    <td>
                        <select class="_color _alignRight" [(ngModel)]="decision.secondaryCommunicationAxis"
                                (ngModelChange)="updateScoreImage()"
                                [disabled]="decisionsReadonly">
                            <option
                                *ngFor="let axis of parameters.communicationParameters.communicationAxes | keys"
                                [value]="axis">
                                {{'axis.' + axis | translate}}
                            </option>
                        </select>
                    </td>
                </tr>
                </tbody>
            </table>

            <kiwi-score-image class="cell shrink"
                              [imgType]="'_communication'"
                              [imgQualityClass]="imgClass"
                              [scores]="scores">
            </kiwi-score-image>
        </kiwi-decision-content>
    </div>
</ng-container>
